import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    user: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
    },
  },
  getters: {
    getUser(state) {
      return state.user;
    },
  },
  mutations: {
    setUser(state, user) {
      state.user.id = user.id || state.user.id;
      state.user.firstName = user.firstName || state.user.firstName;
      state.user.lastName = user.lastName || state.user.lastName;
      state.user.email = user.email || state.user.email;
    },
  },
  actions: {
    async initUser(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .get();
      const userData = doc.data();
      state.commit("setUser", userData);
    },
    async login(state, data) {
      const user = (
        await firebase.auth.signInWithEmailAndPassword(
          data.email,
          data.password
        )
      ).user;
      const doc = await firebase.db
        .collection("users")
        .doc(user.uid)
        .get();
      const userData = doc.data();
      state.commit("setUser", userData);
    },
    async recoverPassword(state, email) {
      await firebase.auth.sendPasswordResetEmail(email);
    },
    async register(state, data) {
      const user = (
        await firebase.auth.createUserWithEmailAndPassword(
          data.email,
          data.password
        )
      ).user;
      await firebase.db
        .collection("users")
        .doc(user.uid)
        .set({
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          id: user.uid,
        });
      state.commit("setUser", data);
    },
    async saveUser(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(state.state.uid)
        .update(data);
      state.commit("setUser", data);
    },
  },
};
